module.exports = new __parcel__URL__("jsm-problem-management.d69d01e4.svg").toString();